import {useRef} from 'react'

import {useWidgets} from '~/shell/widgets'

import {AdoptionCentre} from './adoption-centre/adoption-centre'
import {useShowAdoptionCentre} from './adoption-centre/use-show-adoption-centre'
import {HelpCentrePortal} from './help-centre-portal'
import {HelpWidget} from './help-widget'

const HelpCentre = () => {
    const {shouldShowAdoptionCentre} = useShowAdoptionCentre()
    const ref = useRef<HTMLDivElement | null>(null)
    const {isHelpWidgetOpen, setIsHelpWidgetOpen} = useWidgets()

    return (
        <HelpCentrePortal ref={ref}>
            {shouldShowAdoptionCentre ? (
                <AdoptionCentre />
            ) : (
                <HelpWidget portalRef={ref} open={isHelpWidgetOpen} setOpen={setIsHelpWidgetOpen} />
            )}
        </HelpCentrePortal>
    )
}

export default HelpCentre
